import React, { useState, useEffect } from 'react';

const StarIcon: React.FC<{ className?: string, style?: React.CSSProperties }> = ({ className, style }) => (
    <svg className={className} style={style} fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
);


export const AndorraBanner: React.FC = () => {
    const [animationClass, setAnimationClass] = useState('-translate-x-full opacity-0');
    const [isRendered, setIsRendered] = useState(true);

    useEffect(() => {
        // Slide in
        const enterTimer = setTimeout(() => {
            setAnimationClass('translate-x-0 opacity-100');
        }, 500);

        // Slide out
        const exitTimer = setTimeout(() => {
            setAnimationClass('-translate-x-full opacity-0');
        }, 60500); // 60s + 500ms delay

        // Unmount component after exit animation
        const unmountTimer = setTimeout(() => {
            setIsRendered(false);
        }, 61500); // Add ~1s for exit animation

        return () => {
            clearTimeout(enterTimer);
            clearTimeout(exitTimer);
            clearTimeout(unmountTimer);
        };
    }, []);

    if (!isRendered) {
        return null;
    }

    return (
        <div 
            className={`fixed top-24 left-4 z-50 p-3 rounded-lg bg-black/60 backdrop-blur-sm text-white flex items-center gap-2 shadow-lg transition-all duration-700 ease-in-out ${animationClass}`}
        >
            <span className="font-bold text-lg">I</span>
            <div className="relative">
                 <svg 
                    className="w-6 h-6 text-red-500" 
                    style={{ animation: 'pump 1s ease-in-out infinite' }}
                    viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
                {/* Stars */}
                <StarIcon className="absolute -top-3 -left-3 w-3 h-3 text-yellow-400" style={{ animation: 'sparkle 2s linear infinite', animationDelay: '0s' }} />
                <StarIcon className="absolute -top-1 right-[-14px] w-3 h-3 text-yellow-400" style={{ animation: 'sparkle 2s linear infinite', animationDelay: '0.5s' }} />
                <StarIcon className="absolute -bottom-2 right-[-8px] w-3 h-3 text-yellow-400" style={{ animation: 'sparkle 2s linear infinite', animationDelay: '1s' }} />
                <StarIcon className="absolute bottom-[-6px] left-[-8px] w-3 h-3 text-yellow-400" style={{ animation: 'sparkle 2s linear infinite', animationDelay: '1.5s' }} />
            </div>
            <span className="font-bold text-lg">Andorra</span>
        </div>
    );
};